import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import { ChatDetailModel, ChatList } from 'model/modules/chat/chatList';
import { ChatMessageStatus } from 'enums/modules/chat/chatMessageStatus';
import { ChatMessageAuthorType } from 'enums/modules/chat/chatMessageAuthorType';
import mapFileFromApi from 'rtkQuery/sharespro/mapper/shared/mapFileFromApi';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import { mapChatMessageListItemFromApi } from './mapChatMessageListFromApi';
import mapAuthorDataFromApi from './mapAuthorDataFromApi';

const mapChatListFromApi = (
  resp: SharesproApiResponse<ApiChatList>
): ChatList => {
  return {
    chats: mapPaginationListFromApi<ChatDetailModel, ApiChatListItem>(
      resp.data.chats,
      (apiItem) => ({
        id: apiItem.id,
        roomType: apiItem.type,
        name: apiItem.name,
        lastMessage: apiItem.last_message
          ? {
              id: apiItem.last_message.id,
              authorData:
                apiItem.last_message.author_data !== null
                  ? mapAuthorDataFromApi(apiItem.last_message.author_data)
                  : null,
              status: ChatMessageStatus.Sent,
              updated: apiItem.last_message.updated ?? false,
              chatId: apiItem.last_message.chat_id ?? -1,
              authorType: apiItem.last_message.author as ChatMessageAuthorType,
              managerName: apiItem.last_message.manager_name ?? null,
              text: apiItem.last_message.content ?? null,
              createdAt: new Date(apiItem.last_message.create_timestamp * 1000),
              files: apiItem.last_message.files ?? [],
            }
          : null,
        type: apiItem.type as ChatRoomType,
        unreadMessageCount: apiItem.unread_message_count ?? 0,
        icon: apiItem.icon !== null ? mapFileFromApi(apiItem.icon) : null,
        members: apiItem.members,
        isSendable: apiItem.is_sendable,
        messages:
          apiItem.messages?.map((value) =>
            mapChatMessageListItemFromApi(value)
          ) ?? [],
      })
    ),
    totalUnreadMessages: resp.data.total_unread_message,
  };
};

export default mapChatListFromApi;
